import styled from "styled-components";
import { FlexContainer } from "styled/Box";

export const ButtonsContainer = styled(FlexContainer)`
  position: absolute;
  right: 32px;
  top: 36px;
`;
